import Swal from 'sweetalert2';
import { listPaisesGafi } from '../api/pldApi';

/** Catálogo SAT usa ZAR para RDC; ISO vigente es COD (lista GAFI). */
const ALIAS_GAFI = {
    ZAR: 'COD',
};

let cacheCodigos = null;
let pending = null;

function normalizarCodigo(codigo) {
    if (!codigo || typeof codigo !== 'string') return '';
    const c = codigo.toUpperCase().trim();
    return ALIAS_GAFI[c] || c;
}

/**
 * Carga (y cachea) los códigos ISO alpha-3 de jurisdicciones GAFI.
 * @returns {Promise<Set<string>>}
 */
export async function getCodigosGafi() {
    if (cacheCodigos) return cacheCodigos;
    if (pending) return pending;
    pending = listPaisesGafi()
        .then((mapa) => {
            const keys = Object.keys(mapa || {}).map((k) => k.toUpperCase());
            cacheCodigos = new Set(keys);
            if (cacheCodigos.has('COD')) cacheCodigos.add('ZAR');
            return cacheCodigos;
        })
        .catch(() => {
            pending = null;
            return new Set();
        });
    return pending;
}

export function esCodigoGafi(codigo, setCodigos) {
    const normalizado = normalizarCodigo(codigo);
    if (!normalizado || !setCodigos) return false;
    return setCodigos.has(normalizado);
}

/**
 * Muestra la alerta de jurisdicción GAFI si el código está en la lista.
 * No bloquea el guardado: el estado del formulario ya debe haberse actualizado.
 * @returns {Promise<boolean>} true si se mostró la alerta
 */
export async function alertarSiPaisGafi(clave, nombre) {
    const setCodigos = await getCodigosGafi();
    if (!esCodigoGafi(clave, setCodigos)) return false;
    const etiqueta = nombre || clave;
    await Swal.fire({
        icon: 'warning',
        title: '⚠️ Jurisdicción de Alto Riesgo — GAFI',
        html: `El país <strong>${etiqueta}</strong> está en listas GAFI (alto riesgo).<br/>Se requiere debida diligencia reforzada y revisión del REC.`,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#dc3545',
    });
    return true;
}
